import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=f1a2a75a&scoped=true"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a2a75a",
  null
  
)

export default component.exports